import { Divider, Empty, IconFont } from '@byecode/ui'
import { useVirtualizer } from '@tanstack/react-virtual'
import { find } from 'rambda'
import * as React from 'react'
import { useCallback, useMemo, useRef } from 'react'

import type { UserOption } from '../../../types'
import { getImageFullUrlInApplication } from '../../../utils'
import { UserAvatar } from '../../UserAvatar'
import * as SC from './styles'

interface DropDownListProps {
    options: UserOption[]
    value: string[]
    appId?: string
    onChange: (val: string) => void
}

export const DropDownList: React.FunctionComponent<DropDownListProps> = ({ options, value, appId, onChange }) => {
    const scrollYRef = useRef<HTMLDivElement>(null)
    const rowVirtualizer = useVirtualizer({
        count: options.length,
        scrollPaddingStart: 0,
        getScrollElement: () => scrollYRef.current,
        estimateSize: () => 48
        //  overscan: rowOverscan
    })

    const renderAvatar = useCallback(
        (item: UserOption) => {
            const { id, name, avatar } = item
            if (id === '{currentUserId}') {
                return <IconFont size={22} type="UserCircle" />
            }
            return <UserAvatar id={id} name={name} avatar={getImageFullUrlInApplication(appId, avatar)} style={{ flexShrink: 0 }} />
        },
        [appId]
    )

    return (
        <SC.TagList ref={scrollYRef}>
            <SC.TagWrapper style={{ height: `${rowVirtualizer.getTotalSize()}px`, width: '100%', position: 'relative' }}>
                {rowVirtualizer.getVirtualItems().map((row, index) => {
                    const item = options[row.index]
                    return (
                        <SC.TagItem
                            style={{
                                // ...style,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                // height: 40,
                                transform: `translateY(${row.start}px)`
                            }}
                            key={options[index].id}
                            onClick={() => onChange(item.id)}
                        >
                            <SC.LeftFill>
                                {renderAvatar(item)}
                                <SC.Title>{item.name}</SC.Title>
                            </SC.LeftFill>
                            {value.includes(item.id) && <SC.Icon type="Tick" />}
                        </SC.TagItem>
                    )
                })}
            </SC.TagWrapper>
        </SC.TagList>
    )
}
